import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-boleto-pre-pago',
  template: `
  <router-outlet></router-outlet>
`,
})
export class BoletoPrePagoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
